var map = {
	"./emergency_kit_01.jpg": "90e7",
	"./emergency_kit_02.jpg": "a156",
	"./emergency_kit_03.jpg": "5a1f",
	"./emergency_kit_04.jpg": "bbd6",
	"./emergency_kit_05.jpg": "e4f4",
	"./emergency_kit_06.jpg": "4e5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8915";